import { useScrollPos } from '@utils/hooks/useScroll';
import classnames from 'classnames/bind';
import styles from './companyTopButton.module.scss';

const cx = classnames.bind(styles);

const CompanyTopButton = () => {
  const { top } = useScrollPos();
  const isTopButtonVisible = top > 0;

  if (!isTopButtonVisible) return null;

  return (
    <a href="#" className={cx('btnTop')} role="button">
      <span className={cx('hidden')}>최상단으로 가기</span>
    </a>
  );
};

export default CompanyTopButton;
